import { createFileRoute } from "@tanstack/react-router";
import { Alert, Separator } from "@heroui/react";

export const Route = createFileRoute("/notice/span_warning")({
  component: SpanWarningPage,
});

export default function SpanWarningPage() {
  return (
    <div className="flex h-screen flex-col gap-4 p-6">
      <div className="text-2xl font-bold">关于近期冒充平台官方客服的公告</div>
      <Separator />
      <div className="text-gray-800">
        近期，我们陆续接到反馈出现用户下单后以
        <span className="text-red-500">“画师未通过平台收款认证”</span>
        为由引导画师扫码通过站外联系或是通过假的客服页面进行身份验证，截图如下：
        <div className="mt-6 grid grid-cols-1 gap-6 rounded-lg border bg-gray-200 p-2 md:grid-cols-2">
          <img
            src="https://oss.furries.cn/static/notice/span_warning/IMG_0689.JPG"
            alt="span_warning"
            className="h-auto w-full rounded-lg object-cover"
          />
          <img
            src="https://oss.furries.cn/static/notice/span_warning/IMG_0690.JPG"
            alt="span_warning"
            className="h-auto w-full rounded-lg object-cover"
          />
          <div className="text-sm text-gray-500">图：骗子冒充客服的第三方网站</div>
        </div>
      </div>
      <div>
        <Alert status="danger">
          <Alert.Indicator />
          <Alert.Content>
            <Alert.Description className="text-red-500">
              此类客服为假客服，通过二维码引导到假冒网站，不属于兽聚汇APP！请认准官方网址
              “furries.cn”
            </Alert.Description>
          </Alert.Content>
        </Alert>
      </div>
      <div>
        平台官方客服不会主动联系用户，也不会要求用户提供任何敏感信息，更不会通过站外要求缴纳任何保证金！！
      </div>
      <Separator />
      <section className="flex flex-col gap-8">
        <div>
          <div className="mb-2 text-xl font-bold">Q：我为什么会遇到骗子？</div>
          <div>
            A：一般情况下，平台要求委托人需要先行下单才可与您发送消息。由于橱窗、集市需要先付款才可下单，因此骗子无法通过上述两个途径联系您。但邀请委托的“先下单、后定价”的流程导致骗子得以钻空子与您取得联系。
          </div>
        </div>
        <div>
          <div className="mb-2 text-xl font-bold">Q：骗子的目标和特征有哪些？</div>
          <div className="mb-2">
            A：本次事件主要针对平台常稿画师。骗子多数使用未实名帐号进行下单，发送钓鱼信息，引导您脱离平台交易，骗取您的个人资料和钱款。
          </div>
          <div className="grid grid-cols-1 gap-6 rounded-lg border bg-gray-200 p-2 md:grid-cols-2">
            <img
              src="https://oss.furries.cn/static/notice/span_warning/37018BF76ECE4AECEDAF01DBAB7D6A03.jpg"
              alt="span_warning"
              className="h-auto w-full rounded-lg object-cover"
            />
            <img
              src="https://oss.furries.cn/static/notice/span_warning/QQ20251215-142049.png"
              alt="span_warning"
              className="h-auto w-full rounded-lg object-cover"
            />
            <div className="text-sm text-gray-500">
              图：骗子通过P图，试图伪造系统消息，尝试引导站外交易
            </div>
          </div>
        </div>
        <div>
          <div className="mb-2 text-xl font-bold">Q：我遇到了这样的骗子，我该如何举报？</div>
          <div className="mb-2">
            A：您可点击对方个人资料，通过左下角举报按钮，附上聊天记录截图举证来向我们提交举报。客服核实后，会立刻采取封号处理
          </div>
          <div className="rounded-lg border bg-gray-200 p-2">
            <img
              src="https://oss.furries.cn/static/notice/span_warning/QQ20251215-141333.png"
              alt="span_warning"
              className="h-auto w-full rounded-lg object-cover"
            />
          </div>
        </div>
        <div>
          <div className="mb-2 text-xl font-bold">
            Q：我有什么办法可以提前杜绝这些骗子骚扰？
          </div>
          <div className="mb-2">
            A：平台提供了“仅接受实名认证用户委托”功能，我们强烈建议您开启该功能，减少交易风险！
          </div>
          <div className="rounded-lg border bg-gray-200 p-2">
            <img
              src="https://oss.furries.cn/static/notice/span_warning/45EE23CEF38C4C7C5199C1A5C08E8E88.PNG"
              alt="span_warning"
              className="h-auto w-full rounded-lg object-cover"
            />
          </div>
        </div>
      </section>

      <section className="my-8 pb-16">
        <div className="mb-2 text-2xl font-bold">最后的最后</div>
        <div>
          不脱离平台交易是底线！一定要牢记！
          <span className="text-red-500">
            平台存在的目的是保障交易安全，因此不论任何情况要求线下交易一定是骗子！
          </span>
          平台官方客服不会主动联系用户，也不会要求用户提供任何敏感信息，更不会通过站外要求缴纳任何保证金！！
        </div>
        <div className="mt-2 font-bold">
          如果您无法鉴别是否是骗子，请第一时间通过帮助中心寻求客服帮助！脱离平台后发生的任何交易纠纷，平台无法提供任何帮助！
        </div>
      </section>
    </div>
  );
}
